export enum KycPaymentGatewayStatus {
  UNSUBMITED = "UNSUBMITED",
  INREVIEW = "INREVIEW",
  VALIDATED = "VALIDATED",
  REJECTED = "REJECTED",
}
